module.exports = __webpack_public_path__ + "img/21.87bdabe9.jpg";